import { useDeepCompareEffect } from 'react-use';
import { useRoutes } from 'hooks';
import { useAsync } from 'react-async';
import { isEqual } from 'lodash';

const useSetBreadcrumbName = ({ path, query, variables, formatData }) => {
  const { setRouteName } = useRoutes();

  // "new" is the create route, not an id: nothing to fetch or to name
  const isNewRoute = path.endsWith('/new');

  const { data: breadcrumbData } = useAsync({
    promiseFn: isNewRoute ? undefined : query,
    ...variables,
    watchFn: (props, prevProps) => {
      return !isEqual(props.filters, prevProps.filters);
    },
  });

  useDeepCompareEffect(() => {
    if (isNewRoute) {
      return;
    }
    setRouteName({
      path,
      name: formatData(breadcrumbData),
    });
  }, [{ path, breadcrumbData }]);

  return null;
};

export default useSetBreadcrumbName;
